module.exports = __webpack_public_path__ + "img/组1(1).a32f454e.png";